export * from './icon.component';
